// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__18x1M","row":"styles_row__2JvyY"};